/**
 * supporterProfileService — role-specific profile for the four TB supporter
 * personas. Wraps /supporters/profile (GET/PUT). Holds awareness / community /
 * organisation metadata only — NO bank, payment, donation or financial field.
 * Basic identity (name, bio, phone) stays on User and is edited via PUT /users/me.
 */
import api from './api'
import type { ApiResponse } from '../types'

export interface SupporterProfile {
  id: number
  userId: number
  userType?: string
  organizationName?: string
  logoUrl?: string
  industry?: string
  location?: string
  areasOfOperation?: string
  focusAreas?: string
  nutritionInterests?: string
  awarenessInterests?: string
  communityPreferences?: string
  preferredLanguage?: string
  website?: string
  contactPerson?: string
  description?: string
  updatedAt?: string
}

export type SupporterProfileRequest = Partial<Omit<SupporterProfile, 'id' | 'userId' | 'userType' | 'updatedAt'>>

/** GET /supporters/profile — get (or auto-create) the caller's role profile. */
export async function getMySupporterProfile(): Promise<SupporterProfile> {
  const res = await api.get<ApiResponse<SupporterProfile>>('/supporters/profile')
  return res.data.data
}

/** PUT /supporters/profile — partial update of the caller's role profile. */
export async function updateMySupporterProfile(
  data: SupporterProfileRequest,
): Promise<SupporterProfile> {
  const res = await api.put<ApiResponse<SupporterProfile>>('/supporters/profile', data)
  return res.data.data
}